export const getGames = (state) => {
  return state.games.gamesList;
};
